import React from 'react';

const SvgCf = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CF_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CF_svg__b" fill="#fff">
        <use xlinkHref="#CF_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#083D96" mask="url(#CF_svg__b)" d="M0 0h28v5.333H0z" />
      <path fill="#37AE39" mask="url(#CF_svg__b)" d="M0 9.333h28v5.333H0z" />
      <path fill="#FFD13F" mask="url(#CF_svg__b)" d="M0 14.667h28V20H0z" />
      <path
        fill="#E42346"
        mask="url(#CF_svg__b)"
        d="M10.667 0h6.667v20h-6.667z"
      />
      <path
        fill="#FFD03B"
        mask="url(#CF_svg__b)"
        d="M4.667 3.447l-1.176.838.434-1.377-1.16-.86 1.443-.012.459-1.37.458 1.37 1.444.013-1.16.859.433 1.377z"
      />
    </g>
  </svg>
);

export default SvgCf;
